export default {
  totalSalesBySegment: 'Total de {kpi} por Segmento',
  dataView: 'Visualização de Dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como Imagem'
}
